import { useEffect } from 'react';

// Honor /#section links arriving from other pages (nav "Home" / "Contact Jess").
export const useHashScroll = (delayMs = 300) => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);
};
